//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import GenericModal from "@Shared/components/modals/generic-modal.vue";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "TemplateEditorHelpModal",
  components: {
    GenericModal
  },
  data() {
    return {
      namesTag: "{{FIRST_NAME}} {{LAST_NAME}}",
      addressTag: "{{ADDRESS}}",
      emailSignatureTag: "{{EMAIL_SIGNATURE}}"
    };
  }
});